import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/* Under a flagged version's label inside the version list: what the check found. Resets the option's nowrap so a long
 * note wraps. */
export const ReviewNote = styled(Text).attrs({ tag: 'span' as const })`
  margin-top: ${SPACE[2]};
  white-space: normal;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: ${COLORS.textMuted};
`;
